
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FF4368","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M11 22c6.065 0 11-4.935 11-11S17.065 0 11 0 0 4.935 0 11s4.935 11 11 11zM11 .98C16.525.98 21.02 5.476 21.02 11c0 5.525-4.495 10.02-10.02 10.02C5.475 21.02.98 16.524.98 11 .98 5.475 5.476.98 11 .98z"}}),_c('path',{attrs:{"d":"M8.289 10.011a2.031 2.031 0 100-4.062 2.031 2.031 0 000 4.062zm0-3.081a1.05 1.05 0 110 2.1 1.05 1.05 0 010-2.1zm3.268 7.213a2.031 2.031 0 104.062 0 2.031 2.031 0 00-4.062 0zm3.082 0a1.05 1.05 0 11-2.1 0 1.05 1.05 0 012.1 0zM7.29 17.205c.253.16.59.091.755-.155l7.709-11.52a.52.52 0 00.03-.53.546.546 0 00-.457-.292.55.55 0 00-.487.242L7.132 16.47a.523.523 0 00.159.735z"}})])])
          )
        }
      }
    